// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"202":"06026c46","211":"47aa83f8","281":"15d2a935","298":"a339cca7","344":"f374cf5d","634":"669cb483","683":"9d3567e3","787":"6034518f","938":"c657d944"}[chunkId] + ".chunk.js";
};